<template>
  <div>
    <div class="columns">
      <div
        class="column is-6 content"
        v-html="findVariable('meedoen_doe_mee_tekst')"
      ></div>
      <div class="column">
        <carrousel :page="'meedoen_doemee'" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: [],
  data() {
    return {};
  },
  computed: {},
  methods: {},
  mounted() {},
};
</script>
